module.exports = __webpack_public_path__ + "media/assets/consultation/project_type_app-4bd3ad086a6562ce13e2c8013499a346.svg";